export class WorkOrderReq{
    id: number;
    workOrderNo:string;
    workOrderDate:Date
    remarks:string;
    plantId: number;
    createdUser: string;
    workOrderItems: WorkOrderItemsReq[];
    constructor(
        id: number,
        workOrderNo:string,
        workOrderDate:Date,
        remarks:string,
        plantId: number,
        createdUser: string,
        workOrderItems: WorkOrderItemsReq[]
    ){
        this.id = id;
        this.workOrderNo = workOrderNo;
        this.workOrderDate = workOrderDate;
        this.remarks = remarks;
        this.plantId = plantId;
        this.createdUser = createdUser;
        this.workOrderItems = workOrderItems;
    }
}

export class WorkOrderItemsReq{
    id: number;
    baleId: number
    quantity: number;
    constructor(
        id: number,
        baleId: number,
        quantity: number
    ){
        this.id = id;
        this.baleId = baleId;
        this.quantity = quantity;
    }
}